// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure the page-content has enough padding to avoid footer overlap */
.page-content.candidate-form {
  padding-bottom: 90px; /* Adjust based on footer height */
  min-height: calc(100vh - 100px); /* Ensure content takes full viewport height minus header/footer */
}

/* view form css */

.admin-dash .p-tabview-nav {
  gap: 3%;
  padding-left: 30px;
}

.admin-dash .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: 1px solid #eee;
  margin-bottom: 10px;
  border-radius: 4px;
}

.user-box {
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  margin-top: 10px;
}

.admin-dash {
  margin-top: 6%;
  margin-bottom: 5%;
}

.admin-dash .p-column-title {
  font-weight: 600;
}

.admin-dash .p-datatable .p-datatable-thead>tr>th {
  padding: 10px 8px;
}

.admin-dash .p-dropdown:not(.p-disabled):hover {
  background-image: var(--backclr) !important;
}


.breadcrumb ol {
  padding-left: 0px;
}

.breadcrumb .p-breadcrumb {
  border: none;
  padding: 10px 0px;
}

.storage img {
  width: 120px;
}

.head-user {
  font-size: 17px;
  font-weight: 600;
}

.usermanagement-tab .p-tabview-nav {
  gap: 0px !important;
  padding-left: 0px;
  background-color: #f3f4f6 !important;
  width: fit-content;
  border-radius: 5px;
  border: 1px solid #e3e3e36b;
}

.usermanagement-tab .p-tabview-nav .p-unselectable-text.p-tabview-selected.p-highlight a {
  margin: 0px;
}

.usermanagement-tab .p-tabview-nav .p-tabview-nav-link {
  margin: 0px;
}

.usermanagement-tab .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  margin: 0px !important;
}

.usermanagement-tab .p-tabview-nav-link {
  margin: 0px !important;
}

.usermanagement-main .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: none;
}

.heading-sz {
  font-size: 16px;
  font-weight: 600;
}

.heading-szm {
  font-size: 15px;
  font-weight: 600;
}

.usermanagement-main .p-tabview-panels {
  padding: 0px;
  margin-top: 25px;
margin-bottom: 80px;
}

.usermanagement-main .p-button {
  border-radius: 4px !important;
}


body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  position: relative;
}

body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a:hover {
  content: attr(data-full-text);
  white-space: normal;
}

body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li.mm-active a {
  font-weight: 600;
}

.lookup-cust a {
  background-color: #eaf1fb;
  color: #000;
}

.lookup-customization-page {
  background: #f6f9fd;
  min-height: calc(100vh - 72px);
  padding-bottom: 32px;
}

.lookup-customization-shell {
  max-width: 1560px;
  margin: 0 auto;
  padding: 8px 22px 28px;
}

.lookup-customization-header {
  align-items: center;
  background: linear-gradient(135deg, #ffffff 0%, #f2f7fd 100%);
  border: 1px solid #d9e5f2;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(24, 64, 104, 0.06);
  display: flex;
  justify-content: space-between;
  margin: 14px 0 22px;
  padding: 22px 26px;
}

.lookup-customization-eyebrow {
  color: #1765a5;
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  margin-bottom: 5px;
}

.lookup-customization-header h1 {
  color: #123e68;
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}

.lookup-customization-header p {
  color: #647991;
  font-size: 14px;
  margin: 5px 0 0;
}

.lookup-customization-summary {
  align-items: center;
  background: #e8f2fc;
  border: 1px solid #c9def2;
  border-radius: 8px;
  color: #1765a5;
  display: flex;
  font-size: 13px;
  font-weight: 600;
  gap: 9px;
  padding: 11px 14px;
  white-space: nowrap;
}

.lookup-customization-grid {
  margin-left: -10px;
  margin-right: -10px;
}

.lookup-customization-grid > [class*="col-"] {
  padding-left: 10px;
  padding-right: 10px;
}

.lookup-cust .p-accordion .p-accordion-header .p-accordion-header-link {
  align-items: center;
  background: #ffffff;
  border: 1px solid #d7e3ef;
  border-radius: 9px !important;
  color: #163b61;
  font-size: 15px;
  font-weight: 600;
  min-height: 56px;
  padding: 15px 17px !important;
  transition: background-color .2s ease, border-color .2s ease, box-shadow .2s ease;
}

.lookup-cust .p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:hover {
  background: #f4f8fd;
  border-color: #8bb9e2;
  box-shadow: 0 3px 10px rgba(25, 88, 145, .08);
}

.lookup-cust .p-accordion .p-accordion-header.p-highlight .p-accordion-header-link {
  background: #eaf4ff;
  border-color: #3389d2;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  color: #075b9f;
}

.lookup-cust .p-accordion .p-accordion-content {
  background: #ffffff;
  border: 1px solid #d7e3ef;
  border-top: 0;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
  padding: 16px;
}

.lookup-cust .p-datatable-wrapper {
  overflow-x: hidden;
}

.lookup-cust .p-datatable-table {
  min-width: 0 !important;
  table-layout: fixed;
  width: 100% !important;
}

.lookup-cust .p-datatable-thead > tr > th,
.lookup-cust .p-datatable-tbody > tr > td {
  border: 1px solid #dbe4ee;
  overflow-wrap: anywhere;
  white-space: normal;
}

.lookup-cust .lookup-resume-source-table .p-datatable-thead > tr > th,
.lookup-cust .lookup-resume-source-table .p-datatable-tbody > tr > td {
  vertical-align: middle;
}

.lookup-cust .lookup-resume-source-table .p-datatable-thead > tr > th:nth-child(1),
.lookup-cust .lookup-resume-source-table .p-datatable-tbody > tr > td:nth-child(1) {
  width: 30% !important;
}

.lookup-cust .lookup-resume-source-table .p-datatable-thead > tr > th:nth-child(2),
.lookup-cust .lookup-resume-source-table .p-datatable-tbody > tr > td:nth-child(2) {
  width: 30% !important;
}

.lookup-cust .lookup-resume-source-table .p-datatable-thead > tr > th:nth-child(3),
.lookup-cust .lookup-resume-source-table .p-datatable-tbody > tr > td:nth-child(3) {
  text-align: center;
  width: 18% !important;
}

.lookup-cust .lookup-resume-source-table .p-datatable-thead > tr > th:nth-child(4),
.lookup-cust .lookup-resume-source-table .p-datatable-tbody > tr > td:nth-child(4) {
  text-align: center;
  width: 22% !important;
}

.lookup-cust .p-datatable-thead > tr > th:last-child,
.lookup-cust .p-datatable-tbody > tr > td:last-child {
  min-width: 84px;
  text-align: center;
  width: 16% !important;
}

.lookup-cust .p-datatable-tbody > tr > td:last-child > div {
  justify-content: center !important;
  flex-wrap: wrap;
}

.lookup-cust .p-accordion {
  margin-top: 0 !important;
  margin-bottom: 18px;
}


.lookup-cust .p-button.p-button-info {
  background-color: transparent;
}

.lookup-cust .p-button.p-button-danger {
  background-color: transparent;

}

.lookup-cust button {
  border-radius: 4px;
}

@media (max-width: 767px) {
  .lookup-customization-shell {
    padding-left: 12px;
    padding-right: 12px;
  }

  .lookup-customization-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
    padding: 18px;
  }

  .lookup-customization-summary {
    width: 100%;
  }
}

.job-posting-container {
  display: flex;
  justify-content: center;
  padding: 16px;
  background-color: var(--white);
  /* min-height: 100vh; */
  color: white;
}

.job-posting-card {
  width: 100%;
  max-width: 800px;
  background-color: var(--white);
  color: var(--black);
  /* border: 1px solid #2d3748; */
  border-radius: 8px;
  padding: 24px;
}

.job-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.job-logo {
  width: 64px;
  height: 64px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  color: #1a202c;
  font-weight: bold;
  font-size: 14px;
}

.job-header-content {
  flex: 1 1;
}

.company-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

.job-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
}

.job-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.job-badge {
  padding: 4px 8px;
  background-color: var(--gsbgcolor);
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.divider {
  height: 1px;
  background-color: #2d3748;
  margin: 24px 0;
}

.job-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

.section-content {
  color: var(--black);
}

.job-list {
  padding-left: 24px;
  color: var(--black);
  list-style-type: disc;
  line-height: 1.5;
}

.job-list-ordered {
  padding-left: 24px;
  color: var(--black);
  list-style-type: decimal;
  line-height: 1.5;
}



/* start */


.application-form-container {
  padding: 1rem;
  max-width: 800px;
  margin: auto;
  color: #fff;
  background: var(--white);
}

.application-card {
  /* padding: 1.5rem; */
  border-radius: 8px;
  background: #1e1e1e;
}

.form-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: #000;
}

.form-subtitle,
.quick-apply-title,
.option-description {
  color: #000;
  margin-bottom: 1rem;
  border-radius: 5px;
}

.quick-apply-flex {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.option-wrapper {
  flex: 1 1;
}

.option-card {
  text-align: center;
  padding: 10px;
  border-radius: 6px;
  background: var(--white);
  border: 1px solid #eee;
}

.apply-small-form .p-button {
  margin: 0.5rem 0;
  /* width: 100%; */
  border-radius: 5px;

}

.apply-small-form .p-card .p-card-content {
  padding: 10px 0px;
}

.candidate-form .card {
  margin-bottom: 5px;
}

.job-id {
  font-weight: 500;
}

.thankyou-img {
  width: 250px;
  border-radius: 50%;
  margin: 0 auto;
  display: block;
}

.reminder-popup .p-card .p-card-content {
  padding: 0px !important;
}

.reminder-popup .p-card .p-card-body {
  padding: 10px 20px !important;

}

.reminder-btn {
  width: 50%;
  border-radius: 4px;
}

.reminder-btnfull {
  width: 100%;
  border-radius: 4px;
  margin-top: 10px;
}

.reminder-popup .p-card-body {
  border: 1px solid #eeeeee;
  border-radius: 4px;
  background-color: #f9fafb;
}

.reminder-popup .p-card {
  box-shadow: none;
}

.profile-back {
  background-color: #eee;
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 50%;
}

.profile-name {
  font-size: 15px;
  font-weight: 800;
}

.role-name {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 4px;
}

.interview-details {
  background-color: #f9fafb;
  border: 1px solid #eee;
}

.reminder-popup .p-menu {
  width: 120px;
}

.p-tag {
  background: #6365f12e;
  color: #000;
  font-size: 0.75rem;
  font-weight: 400;
  padding: 0.25rem 0.8rem;
  border-radius: 16px;
}

.p-tag.p-tag-success {
  background-color: #22c55e5c;
  color: #4b5563;
}

.p-tag.p-tag-info {
  background-color: #0ea5e947;
  color: #000;
}

.interview-details .p-button {
  background-color: transparent;
  border: none;
}

.interview-details .p-button:not(:disabled):hover {
  background-color: transparent;
  border: none;
}

.active-card1 {
  border: 2px solid #0e527d !important;
  box-shadow: 0 0 10px rgba(0, 122, 217, 0.5);
}

.datatable-check input[type="checkbox"] {
  margin: auto;
  display: block;
}

.action-icons i {
  font-size: 16px;
  /* color: var(--black); */
}

.action-icons .mainbtn:hover i {
  color: var(--white);
}


@media screen and (max-width: 768px) {
  .quick-apply-flex {
    flex-direction: column;
  }

  .option-wrapper {
    width: 100%;
  }
}

.pipe-table .p-badge.p-badge-success {

  padding: 1px 2px;
  font-size: 12px;
}

.view-form-sidebar.table-sec .p-tabview .p-tabview-nav {
  justify-content: space-between;
  padding-left: 10px !important;
  margin-bottom: 10px !important;
}

.view-form-sidebar.table-sec .p-dropdown {
  background: var(--backclr);
  border: none;
}

.view-form-sidebar .p-dropdown:not(.p-disabled):hover {
  background: var(--backclr);
  border: 1px solid var(--border-color);
}

.dispaly-mob {
  display: none !important;
}

.disply-desk {
  display: none !important;
}

.footer-back .p-paginator-first.p-paginator-element.p-link.p-disabled {
  border-left: 2px solid #e3e3e3;
  height: 25px;
  padding-left: 15px;
}

.footer-tabsec {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-bottom: 0px;
}

.footer-proerty {
  display: flex;
  align-items: center;
}


.close-tabssection ul {
  display: flex;
  flex-wrap: wrap;
}


@media screen and (max-width: 1200px) {
  .dispaly-mob {
    display: block !important;
  }

  .footer-back .p-paginator-first.p-paginator-element.p-link.p-disabled {
    border-left: none;
    height: 25px;
    padding-left: 0px;
  }

}

@media (min-width: 441px) and (max-width: 1450px) {
  .admin-dash {
    margin-top: 14%;
    margin-bottom: 5%;
  }

}

@media screen and (max-width: 440px) {
  .admin-dash {
    margin-top: 24%;
    margin-bottom: 5%;
  }


}


@media screen and (max-width: 575px) {

  .footer-property {
    justify-content: center;

  }

  .footer-back .gear-picklist {
    border-right: none;
    padding-right: none;
    padding: 8px 0px 0px 0px;
  }
}



@media screen and (max-width: 1199px) {
  .admin-dash {
    margin-bottom: 13%;
  }

  .admin-dash .p-tabview-nav {
    gap: 2%;
  }

  .adminsetting-page {
    margin-bottom: 80px;
  }

}


@media screen and (min-width: 1201px) {

  .disply-desk {
    display: flex !important;
    justify-content: end !important;
  }

}

datatable-size .p-datatable .p-datatable-tbody>tr>td {
  padding: 2px 12px 2px 12px !important;
}

/* my accounrt start */

.profile-preview-container {
  max-width: 1500px;
  margin: auto;
  background-color: #fff;
  border: 1px solid #dbe6f1;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(23, 65, 104, 0.07);
  overflow: hidden;
}

.profile-header {
  background: linear-gradient(135deg, #f5f9fd 0%, #edf5fc 100%);
  border-bottom: 1px solid #dbe6f1;
  padding: 28px 30px;
}

.profile-header-content {
  display: flex;
  align-items: center;
  gap: 24px;
}

.profile-image-container {
  position: relative;
}

.profile-image {
  width: 128px;
  height: 128px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.change-photo-btn {
  position: absolute;
  bottom: 10px;
  right: 0;
  color: white;
  padding: 6px 10px;
  border-radius: 50%;
  background-image: var(--blue-gradient-angle);
  cursor: pointer;
  border: none;
}

.profile-name {
  color: #123e68;
  font-size: 21px;
  font-weight: 700;
  margin: 0 0 5px;
}

.profile-role {
  color: #52708e;
  font-size: 14px;
  letter-spacing: .04em;
  margin: 0;
  text-transform: uppercase;
}

.tabs {
  background: #fff;
  border-bottom: 1px solid #dbe6f1;
  display: flex;
  padding-left: 14px;
}

.tab-btn {
  border-bottom: 3px solid transparent;
  color: #52708e;
  cursor: pointer;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 600;
  padding: 14px 24px 12px;
}

.tab-btn.active-tab {
  border-bottom-color: #1672b8;
  color: #12639f;
}

.tab-btn.disabled {
  color: #a0aec0;
  cursor: not-allowed;
}

.profile-content {
  padding: 28px 30px 34px;
  margin-bottom: 0;
}

.profile-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0 26px;
}

.left-column,
.right-column {
  display: flex;
  flex-direction: column;
}

.profile-input {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #dce5ee;
  border-radius: 7px;
  color: #3d5871;
  font-size: 14px;
  min-height: 46px;
  padding: 10px 12px;
}

.profile-content label {
  color: #274d70;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 7px;
}

.profile-content > div:first-child {
  min-height: 0;
}

.profile-preview-container > div[style*="justify-content: flex-end"] {
  padding: 0 30px;
  position: relative;
  top: 18px;
  z-index: 1;
}

.profile-preview-container .change-btn {
  align-items: center;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  padding: 0;
  width: 40px;
}

.linkedin-mapping-page {
  max-width: 1560px;
  padding-bottom: 28px;
}

.linkedin-mapping-header {
  align-items: center;
  background: linear-gradient(135deg, #ffffff 0%, #f1f7fd 100%);
  border: 1px solid #d9e5f2;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(24, 64, 104, .06);
  display: flex;
  justify-content: space-between;
  margin: 14px 0 20px;
  padding: 22px 26px;
}

.linkedin-mapping-eyebrow {
  color: #1765a5;
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  margin-bottom: 5px;
}

.linkedin-mapping-header h1 {
  color: #123e68;
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}

.linkedin-mapping-header p {
  color: #647991;
  font-size: 14px;
  margin: 5px 0 0;
}

.linkedin-mapping-header > i {
  align-items: center;
  background: #e7f1fb;
  border: 1px solid #c7ddf0;
  border-radius: 50%;
  color: #0a66c2;
  display: flex;
  font-size: 22px;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.linkedin-mapping-card {
  background: #fff;
  border: 1px solid #d9e5f2;
  border-radius: 12px;
  box-shadow: 0 5px 18px rgba(24, 64, 104, .06);
  overflow: hidden;
  padding: 18px;
}

.linkedin-mapping-table-wrap {
  overflow-x: auto;
}

.linkedin-mapping-table {
  border: 1px solid #cbd9e6 !important;
  border-collapse: collapse !important;
  border-color: #cbd9e6 !important;
  margin-bottom: 0;
  min-width: 720px;
}

.linkedin-mapping-table thead th {
  background: #f1f6fb;
  border: 1px solid #cbd9e6 !important;
  color: #17466f;
  font-size: 13px;
  font-weight: 700;
  padding: 14px 12px;
  vertical-align: middle;
}

.linkedin-mapping-table tbody td {
  border: 1px solid #d8e3ee !important;
  color: #38566f;
  padding: 14px 12px;
}

.linkedin-mapping-table tbody tr:hover td {
  background: #f7fbff;
}

.linkedin-mapping-table tbody td:first-child {
  color: #163e63;
  font-weight: 600;
}

.linkedin-mapping-table .form-check-input {
  cursor: pointer;
  float: none;
  height: 18px;
  margin: 0;
  width: 18px;
  accent-color: #0a66c2;
  vertical-align: middle;
}

.linkedin-mapping-checkbox-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  min-height: 34px;
  border-radius: 8px;
}

.linkedin-mapping-checkbox-wrap:has(.linkedin-mapping-checkbox:not(:disabled)) {
  cursor: pointer;
}

.linkedin-mapping-checkbox:focus-visible {
  outline: 3px solid rgba(10, 102, 194, 0.28);
  outline-offset: 3px;
}

.linkedin-mapping-table .form-check-input:checked {
  background-color: #0a66c2;
  border-color: #0a66c2;
}

.linkedin-mapping-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 18px;
}

.linkedin-connect-button {
  background: #0a66c2;
  border: 0;
  border-radius: 7px;
  color: #fff;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  min-width: 220px;
  padding: 10px 16px;
  justify-content: center;
  width: auto;
}

.linkedin-connect-button:hover {
  background: #07549f;
}

.upload-resumes .resume-file-card {
  align-items: center;
  background: #fff;
  border: 1px solid #dbe6f1;
  border-radius: 9px;
  display: flex;
  gap: 14px;
  margin: 8px 0;
  padding: 13px 14px;
}

.upload-resumes .resume-file-icon-wrap {
  align-items: center;
  background: #edf5fc;
  border-radius: 8px;
  display: flex;
  flex: 0 0 42px;
  height: 42px;
  justify-content: center;
}

.upload-resumes .resume-file-icon-wrap i {
  font-size: 22px !important;
  margin: 0 !important;
}

.upload-resumes .resume-file-details {
  flex: 1 1 auto;
  min-width: 0;
}

.upload-resumes .resume-file-details strong {
  color: #173f65;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-resumes .resume-file-property-grid {
  color: #6b8094;
  display: grid;
  font-size: 12px;
  gap: 5px 18px;
  grid-template-columns: repeat(4, minmax(80px, 1fr));
  margin-top: 8px;
}

.upload-resumes .resume-file-property-grid span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-resumes .resume-file-property-grid b {
  color: #365b7c;
  display: block;
  font-size: 10px;
  letter-spacing: .04em;
  margin-bottom: 2px;
  text-transform: uppercase;
}

.upload-resumes .resume-file-status {
  flex: 0 0 auto;
  white-space: nowrap;
}

.resume-upload-choice-modal .modal-content {
  border: 1px solid #d6e4f0;
  border-radius: 14px;
  box-shadow: 0 18px 50px rgba(19, 62, 104, .2);
  overflow: hidden;
}

.resume-upload-choice-modal .modal-header {
  background: linear-gradient(135deg, #0e527d, #1a87cb);
  border-bottom: 0;
  color: #fff;
  padding: 18px 22px;
}

.resume-upload-choice-modal .modal-title {
  font-size: 19px;
  font-weight: 700;
}

.resume-upload-choice-modal .btn-close {
  filter: brightness(0) invert(1);
}

.resume-upload-choice-body {
  background: #f6faff;
  padding: 24px;
}

.resume-upload-choice-body > .text-center {
  background: #fff;
  border: 1px solid #dce8f2;
  border-radius: 10px;
  margin-bottom: 18px !important;
  padding: 18px;
}

.resume-upload-pending-list {
  background: #eef6fd;
  border: 1px solid #cfe2f2;
  border-radius: 10px;
  margin-bottom: 18px;
  max-height: 230px;
  overflow-y: auto;
  padding: 10px;
}

.resume-upload-file-card {
  align-items: center;
  background: #fff;
  border: 1px solid #d8e5f0;
  border-radius: 9px;
  display: flex;
  gap: 13px;
  margin-bottom: 8px;
  padding: 12px;
}

.resume-upload-file-card:last-child {
  margin-bottom: 0;
}

.resume-upload-file-icon {
  align-items: center;
  background: #e8f3fc;
  border-radius: 8px;
  color: #176ba7;
  display: flex;
  flex: 0 0 40px;
  font-size: 20px;
  height: 40px;
  justify-content: center;
}

.resume-upload-file-icon .resume-file-pdf-icon {
  color: #d63b43;
  font-size: 22px;
}

.resume-upload-file-icon .resume-file-word-icon {
  color: #2563a8;
  font-size: 22px;
}

.resume-native-file-icon {
  font-size: 24px;
}

.resume-upload-file-details {
  flex: 1 1 auto;
  min-width: 0;
}

.resume-upload-file-details strong {
  color: #173f65;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resume-upload-file-properties {
  color: #6b8094;
  display: grid;
  font-size: 11px;
  gap: 4px 14px;
  grid-template-columns: repeat(4, minmax(70px, 1fr));
  margin-top: 6px;
}

.resume-upload-file-properties span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resume-upload-file-properties b {
  color: #365b7c;
  display: block;
  font-size: 9px;
  letter-spacing: .04em;
  text-transform: uppercase;
}

.resume-upload-file-ready {
  background: #e7f7ef;
  border: 1px solid #b9e4cc;
  border-radius: 999px;
  color: #137a4b;
  flex: 0 0 auto;
  font-size: 11px;
  font-weight: 700;
  padding: 5px 9px;
  white-space: nowrap;
}

.resume-upload-delete-icon {
  background: #fff0f1;
  border: 1px solid #f1b9bd;
  border-radius: 6px;
  cursor: pointer;
  flex: 0 0 30px;
  height: 30px;
  object-fit: contain;
  padding: 6px;
  transition: background-color .2s ease, border-color .2s ease, transform .2s ease;
  width: 30px;
}

.resume-upload-delete-icon:hover {
  background: #dc3545;
  border-color: #dc3545;
  transform: scale(1.06);
}

.swal2-popup.resume-processing-toast {
  align-items: center !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 9px;
  border: 1px solid #d6e4ef !important;
  border-radius: 12px !important;
  box-shadow: 0 12px 32px rgba(19, 62, 104, .18) !important;
  margin-top: 12px !important;
  min-width: 380px;
  padding: 18px 22px 17px !important;
  text-align: center !important;
}

.resume-processing-toast .swal2-title,
.resume-processing-toast .swal2-html-container {
  margin: 0 !important;
  text-align: center !important;
  width: 100%;
}

.resume-processing-toast .swal2-icon {
  margin: 0 auto 2px !important;
  transform: scale(.62);
}

.resume-processing-toast .swal2-title {
  color: #173f65 !important;
  font-size: 15px !important;
  line-height: 1.25;
}

.resume-processing-toast .swal2-html-container {
  color: #6b8094 !important;
  font-size: 13px !important;
}

.resume-processing-toast .swal2-icon.swal2-info {
  border-color: #2b83c5 !important;
  color: #2b83c5 !important;
  margin: 0 auto 2px !important;
  transform: scale(.78);
}

.resume-processing-toast .swal2-actions {
  align-self: center;
  justify-content: center !important;
  margin: 4px 0 0 !important;
  order: 4;
  width: 100%;
}

.resume-processing-toast .swal2-confirm {
  border-radius: 7px !important;
  box-shadow: none !important;
  font-weight: 700 !important;
  margin: 0 !important;
}

.resume-processing-toast #resume-progress-wrapper,
.resume-processing-toast #resume-upload-progress-bar,
.resume-processing-toast #resume-upload-progress-text {
  box-sizing: border-box;
}

.resume-processing-toast #resume-upload-progress-bar {
  background: linear-gradient(90deg, #1269a4, #2f9bd2) !important;
  border-radius: 999px;
}

.resume-processing-toast #resume-progress-wrapper > div:first-child {
  background: #e5edf4 !important;
  border-radius: 999px !important;
  box-sizing: border-box;
  height: 7px !important;
  margin: 0 !important;
  width: 100% !important;
}

.resume-processing-toast #resume-progress-wrapper {
  box-sizing: border-box !important;
  margin: 10px 0 0 !important;
  max-width: 100% !important;
  order: 3;
  padding: 0 18px !important;
  width: 100% !important;
}

.resume-processing-toast #resume-upload-progress-text {
  text-align: center !important;
}

.resume-processing-toast .swal2-html-container {
  order: 2;
}

.resume-upload-choice-body .row.g-3 > div > button {
  border: 1px solid #d6e4ef !important;
  border-radius: 10px !important;
  min-height: 96px;
  transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
}

.resume-upload-choice-body .row.g-3 > div > button:hover {
  border-color: #4a9bd3 !important;
  box-shadow: 0 6px 16px rgba(14, 82, 125, .1);
  transform: translateY(-1px);
}

.job-order-add-candidate-modal .modal-content {
  border: 1px solid #d4e2ee;
  border-radius: 14px;
  box-shadow: 0 20px 55px rgba(12, 50, 82, .24);
  overflow: hidden;
}

.job-order-add-candidate-modal.modal-dialog,
.job-order-add-candidate-modal .modal-dialog {
  max-width: 820px;
  width: calc(100% - 28px);
}

.job-order-add-candidate-modal .modal-header {
  background: linear-gradient(135deg, #0e527d, #1689c9);
  border: 0;
  color: #fff;
  padding: 17px 20px;
}

.job-order-add-candidate-modal .modal-title {
  font-size: 18px;
  font-weight: 700;
}

.job-order-add-candidate-modal .btn-close {
  filter: brightness(0) invert(1);
}

.job-order-add-candidate-body {
  background: #f6faff;
  min-height: 0;
  padding: 22px 20px;
}

.job-order-upload-tabs {
  background: #eaf2f9;
  border-radius: 9px;
  display: flex;
  gap: 5px;
  margin-bottom: 18px;
  padding: 4px;
}

.job-order-upload-tabs button {
  background: transparent !important;
  border: 0 !important;
  border-radius: 7px !important;
  color: #52708e;
  flex: 1 1;
  font-size: 14px;
  font-weight: 600;
  margin: 0 !important;
  padding: 10px 12px !important;
}

.job-order-upload-tabs button.btn.border.blueBtn {
  background: #fff !important;
  box-shadow: 0 2px 7px rgba(20, 76, 119, .12);
  color: #0e527d !important;
}

.job-order-upload-tabs button.btn.border.blueBtn,
.job-order-upload-tabs button.btn.light {
  text-indent: 0 !important;
  visibility: visible !important;
}

.job-order-add-candidate-body .uploadFileClass {
  background: #fff !important;
  border: 2px dashed #8dbbda !important;
  border-radius: 12px !important;
  min-height: 170px;
  padding: 30px 20px !important;
}

.job-order-upload-icon {
  align-items: center;
  background: #e7f3fc;
  border-radius: 50%;
  color: #1477b5;
  display: flex;
  font-size: 28px;
  height: 58px;
  justify-content: center;
  margin: 0 auto 12px;
  width: 58px;
}

.job-order-upload-title {
  color: #17466f;
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 6px;
}

.job-order-add-candidate-body .chooseFileSpan {
  color: #214b6d;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 14px;
}

.job-order-upload-choices {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 8px;
}

.job-order-upload-choices button {
  border-radius: 7px;
  font-weight: 600;
  padding: 8px 13px;
}

.job-order-add-candidate-body .hintText {
  color: #7890a4;
  font-size: 12px;
  margin: 12px 0 0;
}

.job-order-selected-files {
  background: #fff;
  border: 1px solid #d6e4ef;
  border-radius: 11px;
  margin-top: 18px;
  padding: 13px;
}

.job-order-selected-files-header {
  align-items: center;
  border-bottom: 1px solid #e2ebf2;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 2px 3px 11px;
}

.job-order-selected-files-header h6 {
  color: #17466f;
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 2px;
}

.job-order-selected-files-header span {
  color: #74899c;
  font-size: 12px;
}

.job-order-selected-files-header > i {
  color: #1b9a63;
  font-size: 19px;
}

.job-order-selected-files-list {
  max-height: 250px;
  overflow-y: auto;
}

.job-order-add-candidate-body .resume-upload-file-card {
  margin: 8px 0;
}

.job-order-existing-candidates {
  background: #fff;
  border: 1px solid #d6e4ef;
  border-radius: 10px;
  padding: 15px;
}

.job-order-existing-candidates > label {
  color: #214b6d;
  font-size: 14px;
  font-weight: 700 !important;
}

.job-order-add-candidate-footer {
  background: #fff;
  border-top: 1px solid #dbe6ef;
  gap: 8px;
  padding: 14px 20px;
}

.job-order-add-candidate-footer button {
  border-radius: 7px !important;
  font-weight: 600;
  min-width: 94px;
}

@media (max-width: 767px) {
  .upload-resumes .resume-file-card {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .upload-resumes .resume-file-details {
    max-width: calc(100% - 58px);
  }

  .upload-resumes .resume-file-property-grid {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }

  .upload-resumes .resume-file-status {
    margin-left: 56px;
  }
}

@media (max-width: 767px) {
  .linkedin-mapping-header {
    align-items: flex-start;
    gap: 14px;
    padding: 18px;
  }

  .linkedin-mapping-header > i {
    display: none;
  }

  .linkedin-mapping-card {
    padding: 10px;
  }
}

@media (max-width: 767px) {
  .profile-header,
  .profile-content {
    padding-left: 18px;
    padding-right: 18px;
  }

  .profile-grid {
    grid-template-columns: 1fr;
  }

  .profile-preview-container > div[style*="justify-content: flex-end"] {
    padding-right: 18px;
  }
}

.password-container {
  display: flex;
  gap: 10px;
}

.change-btn {
  padding: 8px 16px;
  background-image: var(--blue-gradient-angle);
  color: white;
  border-radius: 4px;
  cursor: pointer;
  border: none;
}

.change-btn:hover {
  background-color: #2b6cb0;
}

.update-btn,
.upload-btn {
  width: fit-content;
  padding: 6px 16px;
  background-image: var(--blue-gradient-angle);
  color: white;
  border-radius: 4px;
  cursor: pointer;
  border: none;
}

.update-btn:hover,
.upload-btn:hover {
  background-color: #2b6cb0;
}

.password-dialog,
.photo-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background-color: rgba(0, 0, 0, 0.5); */
  display: flex;
  justify-content: center;
  align-items: center;
}


.dialog-content {
  background-color: white;
  padding: 30px 30px;
  border-radius: 4px;
  width: 28vw;
  box-shadow: -1px -1px 12px 7px #f1f1f1e6;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.close-btn {
  font-size: 14px;
  border: none;
  background-color: transparent;
  cursor: pointer;
}

.drop-zone {
  border: 2px dashed #cbd5e0;
  padding: 40px;
  text-align: center;
  border-radius: 8px;
  display: flex;
  justify-content: end;
}

.choose-file-btn {
  padding: 10px 20px;
  background-color: #3182ce;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.choose-file-btn:hover {
  background-color: #2b6cb0;
}


.Change-password {
  display: flex !important;
  justify-content: space-between !important;
  margin-bottom: 13px !important;
}

.preview-image-container {
  text-align: center;
  margin-bottom: 10px;
}

.preview-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}

.upload-resumes .custom-choose-btn .p-button-rounded .p-button-outlined .p-button .p-fileupload-choose .p-component .p-button-icon-only {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  border: 1px solid var(--backclr);
  color: var(--white);
  padding: 7px 18px;
}

.upload-resumes .p-button {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  border: 1px solid var(--backclr);
  color: var(--white);
  padding: 7px 18px;
  border-radius: 100%;
}

.import-head{
    font-size: 16px;
    font-weight: 500;
}
.import-head {
  font-size: 16px;
  font-weight: 500;

}

.import-fw {
  font-weight: 500;
}

.main-button {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  color: var(--white);
  border: none !important;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
}

.upload-resumes .p-fileupload-content i{
  display: none;
}


.upload-resumes .p-fileupload-content span{
  margin: 0 !important;
  padding: 0px !important;
  font-size: 15px !important;
  justify-content: start;
}

.clr-icons {
  display: flex;
  justify-content: end;
}

.actionitem-import .csvbtn.p-button {
  color: var(--white);
  background: #06b6d4;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  width: 36px;
  height: 36px;
}
.actionitem-import .xlsbtn.p-button {
  color: var(--white);
  background: #22c55e;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  width: 36px;
  height: 36px;
}
.actionitem-import .pdfbtn.p-button {
  color: var(--white);
  background: #f97316;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  width: 36px;
  height: 36px;
}

.usermanagement-tab .p-datatable .p-datatable-tbody > tr > td{
  padding: 0.1rem 1rem;
}

.profile-dropdown .p-cascadeselect-item-active>.p-cascadeselect-sublist-wrapper {
  display: block;
  left: -123% !important;
  top: 46px !important;
}


/* tab section css start */

.dynamic-tab .p-button {
  background-color: transparent;
  border: none;
  color: var(--black);
  padding: 2px 0px;
  margin: 0;
}

.dynamic-tab .p-button.p-button-icon-only {
  width: 20px;
  background: transparent;
}

.footer-tabsec .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  padding: 3px 10px !important;
  border: 1px solid #e0e0ea3d;
  border-radius: 5px;
}
 .p-menu-list{
  padding-left: 0 !important;
}

/* tab section css end */

/* Pipeline Accordian start */


.pipeline-acc .p-datatable .p-datatable-tbody > tr > td{
  padding: 0rem 1rem;
}

/* Pipeline Accordian end */


/* auto complete start */

.p-autocomplete-items{
  padding-left: 0px;
}


.footer-tabsec, .dynamic-tab {
  width: 100%;
  padding-left: 0;
  padding-right: 0;
}

.tabsmargin{
  margin-top: 100px;
margin-bottom: 100px;
}




.expanded-row {
  background-color: #f0f8ff !important; /* Light blue background for expanded rows */
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/style-new.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,oBAAoB,EAAE,kCAAkC;EACxD,+BAA+B,EAAE,kEAAkE;AACrG;;AAEA,kBAAkB;;AAElB;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB,mBAAmB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uCAAuC;EACvC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;;AAE/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;;;AAIA,UAAU;;;AAGV;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;;AAE/B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,eAAe;AACjB;;;AAGA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;EACnB;;AAEF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;AAEF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;;AAGF;;;AAGA;;EAEE;IACE,uBAAuB;;EAEzB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;EAC1B;AACF;;;;AAIA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,mBAAmB;EACrB;;AAEF;;;AAGA;;EAEE;IACE,wBAAwB;IACxB,+BAA+B;EACjC;;AAEF;;AAEA;EACE,qCAAqC;AACvC;;AAEA,sBAAsB;;AAEtB;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,aAAa;EACb,mDAAmD;EACnD,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;EACd,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,aAAa;EACb,mDAAmD;EACnD,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gFAAgF;EAChF,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,QAAQ;EACR,oCAAoC;EACpC,8BAA8B;EAC9B,yDAAyD;EACzD,2BAA2B;EAC3B,gBAAgB;EAChB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;;EAEE,oBAAoB;EACpB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,+DAA+D;EAC/D,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,QAAQ;EACR,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;EAChB,0EAA0E;AAC5E;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0DAA0D;EAC1D,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0DAA0D;EAC1D,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;AACtB;;;AAGA,0BAA0B;;AAE1B;EACE,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;CACC;EACC,0BAA0B;AAC5B;;AAEA,wBAAwB;;AAExB,6BAA6B;;;AAG7B;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;;;AAG3B,wBAAwB;;AAExB;EACE,iBAAiB;AACnB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB,oBAAoB;AACpB;;;;;AAKA;EACE,oCAAoC,EAAE,4CAA4C;AACpF","sourcesContent":["/* Ensure the page-content has enough padding to avoid footer overlap */\n.page-content.candidate-form {\n  padding-bottom: 90px; /* Adjust based on footer height */\n  min-height: calc(100vh - 100px); /* Ensure content takes full viewport height minus header/footer */\n}\n\n/* view form css */\n\n.admin-dash .p-tabview-nav {\n  gap: 3%;\n  padding-left: 30px;\n}\n\n.admin-dash .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  border: 1px solid #eee;\n  margin-bottom: 10px;\n  border-radius: 4px;\n}\n\n.user-box {\n  border: 1px solid #ccc;\n  padding: 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  text-align: center;\n  margin-top: 10px;\n}\n\n.admin-dash {\n  margin-top: 6%;\n  margin-bottom: 5%;\n}\n\n.admin-dash .p-column-title {\n  font-weight: 600;\n}\n\n.admin-dash .p-datatable .p-datatable-thead>tr>th {\n  padding: 10px 8px;\n}\n\n.admin-dash .p-dropdown:not(.p-disabled):hover {\n  background-image: var(--backclr) !important;\n}\n\n\n.breadcrumb ol {\n  padding-left: 0px;\n}\n\n.breadcrumb .p-breadcrumb {\n  border: none;\n  padding: 10px 0px;\n}\n\n.storage img {\n  width: 120px;\n}\n\n.head-user {\n  font-size: 17px;\n  font-weight: 600;\n}\n\n.usermanagement-tab .p-tabview-nav {\n  gap: 0px !important;\n  padding-left: 0px;\n  background-color: #f3f4f6 !important;\n  width: fit-content;\n  border-radius: 5px;\n  border: 1px solid #e3e3e36b;\n}\n\n.usermanagement-tab .p-tabview-nav .p-unselectable-text.p-tabview-selected.p-highlight a {\n  margin: 0px;\n}\n\n.usermanagement-tab .p-tabview-nav .p-tabview-nav-link {\n  margin: 0px;\n}\n\n.usermanagement-tab .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  margin: 0px !important;\n}\n\n.usermanagement-tab .p-tabview-nav-link {\n  margin: 0px !important;\n}\n\n.usermanagement-main .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  border: none;\n}\n\n.heading-sz {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.heading-szm {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.usermanagement-main .p-tabview-panels {\n  padding: 0px;\n  margin-top: 25px;\nmargin-bottom: 80px;\n}\n\n.usermanagement-main .p-button {\n  border-radius: 4px !important;\n}\n\n\nbody[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  position: relative;\n}\n\nbody[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a:hover {\n  content: attr(data-full-text);\n  white-space: normal;\n}\n\nbody[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li.mm-active a {\n  font-weight: 600;\n}\n\n.lookup-cust a {\n  background-color: #eaf1fb;\n  color: #000;\n}\n\n.lookup-customization-page {\n  background: #f6f9fd;\n  min-height: calc(100vh - 72px);\n  padding-bottom: 32px;\n}\n\n.lookup-customization-shell {\n  max-width: 1560px;\n  margin: 0 auto;\n  padding: 8px 22px 28px;\n}\n\n.lookup-customization-header {\n  align-items: center;\n  background: linear-gradient(135deg, #ffffff 0%, #f2f7fd 100%);\n  border: 1px solid #d9e5f2;\n  border-radius: 12px;\n  box-shadow: 0 4px 16px rgba(24, 64, 104, 0.06);\n  display: flex;\n  justify-content: space-between;\n  margin: 14px 0 22px;\n  padding: 22px 26px;\n}\n\n.lookup-customization-eyebrow {\n  color: #1765a5;\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: .08em;\n  margin-bottom: 5px;\n}\n\n.lookup-customization-header h1 {\n  color: #123e68;\n  font-size: 24px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.lookup-customization-header p {\n  color: #647991;\n  font-size: 14px;\n  margin: 5px 0 0;\n}\n\n.lookup-customization-summary {\n  align-items: center;\n  background: #e8f2fc;\n  border: 1px solid #c9def2;\n  border-radius: 8px;\n  color: #1765a5;\n  display: flex;\n  font-size: 13px;\n  font-weight: 600;\n  gap: 9px;\n  padding: 11px 14px;\n  white-space: nowrap;\n}\n\n.lookup-customization-grid {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n\n.lookup-customization-grid > [class*=\"col-\"] {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.lookup-cust .p-accordion .p-accordion-header .p-accordion-header-link {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #d7e3ef;\n  border-radius: 9px !important;\n  color: #163b61;\n  font-size: 15px;\n  font-weight: 600;\n  min-height: 56px;\n  padding: 15px 17px !important;\n  transition: background-color .2s ease, border-color .2s ease, box-shadow .2s ease;\n}\n\n.lookup-cust .p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:hover {\n  background: #f4f8fd;\n  border-color: #8bb9e2;\n  box-shadow: 0 3px 10px rgba(25, 88, 145, .08);\n}\n\n.lookup-cust .p-accordion .p-accordion-header.p-highlight .p-accordion-header-link {\n  background: #eaf4ff;\n  border-color: #3389d2;\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n  color: #075b9f;\n}\n\n.lookup-cust .p-accordion .p-accordion-content {\n  background: #ffffff;\n  border: 1px solid #d7e3ef;\n  border-top: 0;\n  border-bottom-left-radius: 9px;\n  border-bottom-right-radius: 9px;\n  padding: 16px;\n}\n\n.lookup-cust .p-datatable-wrapper {\n  overflow-x: hidden;\n}\n\n.lookup-cust .p-datatable-table {\n  min-width: 0 !important;\n  table-layout: fixed;\n  width: 100% !important;\n}\n\n.lookup-cust .p-datatable-thead > tr > th,\n.lookup-cust .p-datatable-tbody > tr > td {\n  border: 1px solid #dbe4ee;\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n\n.lookup-cust .lookup-resume-source-table .p-datatable-thead > tr > th,\n.lookup-cust .lookup-resume-source-table .p-datatable-tbody > tr > td {\n  vertical-align: middle;\n}\n\n.lookup-cust .lookup-resume-source-table .p-datatable-thead > tr > th:nth-child(1),\n.lookup-cust .lookup-resume-source-table .p-datatable-tbody > tr > td:nth-child(1) {\n  width: 30% !important;\n}\n\n.lookup-cust .lookup-resume-source-table .p-datatable-thead > tr > th:nth-child(2),\n.lookup-cust .lookup-resume-source-table .p-datatable-tbody > tr > td:nth-child(2) {\n  width: 30% !important;\n}\n\n.lookup-cust .lookup-resume-source-table .p-datatable-thead > tr > th:nth-child(3),\n.lookup-cust .lookup-resume-source-table .p-datatable-tbody > tr > td:nth-child(3) {\n  text-align: center;\n  width: 18% !important;\n}\n\n.lookup-cust .lookup-resume-source-table .p-datatable-thead > tr > th:nth-child(4),\n.lookup-cust .lookup-resume-source-table .p-datatable-tbody > tr > td:nth-child(4) {\n  text-align: center;\n  width: 22% !important;\n}\n\n.lookup-cust .p-datatable-thead > tr > th:last-child,\n.lookup-cust .p-datatable-tbody > tr > td:last-child {\n  min-width: 84px;\n  text-align: center;\n  width: 16% !important;\n}\n\n.lookup-cust .p-datatable-tbody > tr > td:last-child > div {\n  justify-content: center !important;\n  flex-wrap: wrap;\n}\n\n.lookup-cust .p-accordion {\n  margin-top: 0 !important;\n  margin-bottom: 18px;\n}\n\n\n.lookup-cust .p-button.p-button-info {\n  background-color: transparent;\n}\n\n.lookup-cust .p-button.p-button-danger {\n  background-color: transparent;\n\n}\n\n.lookup-cust button {\n  border-radius: 4px;\n}\n\n@media (max-width: 767px) {\n  .lookup-customization-shell {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  .lookup-customization-header {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 14px;\n    padding: 18px;\n  }\n\n  .lookup-customization-summary {\n    width: 100%;\n  }\n}\n\n.job-posting-container {\n  display: flex;\n  justify-content: center;\n  padding: 16px;\n  background-color: var(--white);\n  /* min-height: 100vh; */\n  color: white;\n}\n\n.job-posting-card {\n  width: 100%;\n  max-width: 800px;\n  background-color: var(--white);\n  color: var(--black);\n  /* border: 1px solid #2d3748; */\n  border-radius: 8px;\n  padding: 24px;\n}\n\n.job-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.job-logo {\n  width: 64px;\n  height: 64px;\n  background-color: white;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  color: #1a202c;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.job-header-content {\n  flex: 1;\n}\n\n.company-name {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n\n.job-title {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 16px;\n}\n\n.job-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.job-badge {\n  padding: 4px 8px;\n  background-color: var(--gsbgcolor);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.divider {\n  height: 1px;\n  background-color: #2d3748;\n  margin: 24px 0;\n}\n\n.job-section {\n  margin-bottom: 24px;\n}\n\n.section-title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n\n.section-content {\n  color: var(--black);\n}\n\n.job-list {\n  padding-left: 24px;\n  color: var(--black);\n  list-style-type: disc;\n  line-height: 1.5;\n}\n\n.job-list-ordered {\n  padding-left: 24px;\n  color: var(--black);\n  list-style-type: decimal;\n  line-height: 1.5;\n}\n\n\n\n/* start */\n\n\n.application-form-container {\n  padding: 1rem;\n  max-width: 800px;\n  margin: auto;\n  color: #fff;\n  background: var(--white);\n}\n\n.application-card {\n  /* padding: 1.5rem; */\n  border-radius: 8px;\n  background: #1e1e1e;\n}\n\n.form-title {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n  color: #000;\n}\n\n.form-subtitle,\n.quick-apply-title,\n.option-description {\n  color: #000;\n  margin-bottom: 1rem;\n  border-radius: 5px;\n}\n\n.quick-apply-flex {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.option-wrapper {\n  flex: 1;\n}\n\n.option-card {\n  text-align: center;\n  padding: 10px;\n  border-radius: 6px;\n  background: var(--white);\n  border: 1px solid #eee;\n}\n\n.apply-small-form .p-button {\n  margin: 0.5rem 0;\n  /* width: 100%; */\n  border-radius: 5px;\n\n}\n\n.apply-small-form .p-card .p-card-content {\n  padding: 10px 0px;\n}\n\n.candidate-form .card {\n  margin-bottom: 5px;\n}\n\n.job-id {\n  font-weight: 500;\n}\n\n.thankyou-img {\n  width: 250px;\n  border-radius: 50%;\n  margin: 0 auto;\n  display: block;\n}\n\n.reminder-popup .p-card .p-card-content {\n  padding: 0px !important;\n}\n\n.reminder-popup .p-card .p-card-body {\n  padding: 10px 20px !important;\n\n}\n\n.reminder-btn {\n  width: 50%;\n  border-radius: 4px;\n}\n\n.reminder-btnfull {\n  width: 100%;\n  border-radius: 4px;\n  margin-top: 10px;\n}\n\n.reminder-popup .p-card-body {\n  border: 1px solid #eeeeee;\n  border-radius: 4px;\n  background-color: #f9fafb;\n}\n\n.reminder-popup .p-card {\n  box-shadow: none;\n}\n\n.profile-back {\n  background-color: #eee;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  border-radius: 50%;\n}\n\n.profile-name {\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.role-name {\n  font-size: 14px;\n  font-weight: 400;\n  margin-bottom: 4px;\n}\n\n.interview-details {\n  background-color: #f9fafb;\n  border: 1px solid #eee;\n}\n\n.reminder-popup .p-menu {\n  width: 120px;\n}\n\n.p-tag {\n  background: #6365f12e;\n  color: #000;\n  font-size: 0.75rem;\n  font-weight: 400;\n  padding: 0.25rem 0.8rem;\n  border-radius: 16px;\n}\n\n.p-tag.p-tag-success {\n  background-color: #22c55e5c;\n  color: #4b5563;\n}\n\n.p-tag.p-tag-info {\n  background-color: #0ea5e947;\n  color: #000;\n}\n\n.interview-details .p-button {\n  background-color: transparent;\n  border: none;\n}\n\n.interview-details .p-button:not(:disabled):hover {\n  background-color: transparent;\n  border: none;\n}\n\n.active-card1 {\n  border: 2px solid #0e527d !important;\n  box-shadow: 0 0 10px rgba(0, 122, 217, 0.5);\n}\n\n.datatable-check input[type=\"checkbox\"] {\n  margin: auto;\n  display: block;\n}\n\n.action-icons i {\n  font-size: 16px;\n  /* color: var(--black); */\n}\n\n.action-icons .mainbtn:hover i {\n  color: var(--white);\n}\n\n\n@media screen and (max-width: 768px) {\n  .quick-apply-flex {\n    flex-direction: column;\n  }\n\n  .option-wrapper {\n    width: 100%;\n  }\n}\n\n.pipe-table .p-badge.p-badge-success {\n\n  padding: 1px 2px;\n  font-size: 12px;\n}\n\n.view-form-sidebar.table-sec .p-tabview .p-tabview-nav {\n  justify-content: space-between;\n  padding-left: 10px !important;\n  margin-bottom: 10px !important;\n}\n\n.view-form-sidebar.table-sec .p-dropdown {\n  background: var(--backclr);\n  border: none;\n}\n\n.view-form-sidebar .p-dropdown:not(.p-disabled):hover {\n  background: var(--backclr);\n  border: 1px solid var(--border-color);\n}\n\n.dispaly-mob {\n  display: none !important;\n}\n\n.disply-desk {\n  display: none !important;\n}\n\n.footer-back .p-paginator-first.p-paginator-element.p-link.p-disabled {\n  border-left: 2px solid #e3e3e3;\n  height: 25px;\n  padding-left: 15px;\n}\n\n.footer-tabsec {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-bottom: 0px;\n}\n\n.footer-proerty {\n  display: flex;\n  align-items: center;\n}\n\n\n.close-tabssection ul {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n\n@media screen and (max-width: 1200px) {\n  .dispaly-mob {\n    display: block !important;\n  }\n\n  .footer-back .p-paginator-first.p-paginator-element.p-link.p-disabled {\n    border-left: none;\n    height: 25px;\n    padding-left: 0px;\n  }\n\n}\n\n@media (min-width: 441px) and (max-width: 1450px) {\n  .admin-dash {\n    margin-top: 14%;\n    margin-bottom: 5%;\n  }\n\n}\n\n@media screen and (max-width: 440px) {\n  .admin-dash {\n    margin-top: 24%;\n    margin-bottom: 5%;\n  }\n\n\n}\n\n\n@media screen and (max-width: 575px) {\n\n  .footer-property {\n    justify-content: center;\n\n  }\n\n  .footer-back .gear-picklist {\n    border-right: none;\n    padding-right: none;\n    padding: 8px 0px 0px 0px;\n  }\n}\n\n\n\n@media screen and (max-width: 1199px) {\n  .admin-dash {\n    margin-bottom: 13%;\n  }\n\n  .admin-dash .p-tabview-nav {\n    gap: 2%;\n  }\n\n  .adminsetting-page {\n    margin-bottom: 80px;\n  }\n\n}\n\n\n@media screen and (min-width: 1201px) {\n\n  .disply-desk {\n    display: flex !important;\n    justify-content: end !important;\n  }\n\n}\n\ndatatable-size .p-datatable .p-datatable-tbody>tr>td {\n  padding: 2px 12px 2px 12px !important;\n}\n\n/* my accounrt start */\n\n.profile-preview-container {\n  max-width: 1500px;\n  margin: auto;\n  background-color: #fff;\n  border: 1px solid #dbe6f1;\n  border-radius: 12px;\n  box-shadow: 0 6px 20px rgba(23, 65, 104, 0.07);\n  overflow: hidden;\n}\n\n.profile-header {\n  background: linear-gradient(135deg, #f5f9fd 0%, #edf5fc 100%);\n  border-bottom: 1px solid #dbe6f1;\n  padding: 28px 30px;\n}\n\n.profile-header-content {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.profile-image-container {\n  position: relative;\n}\n\n.profile-image {\n  width: 128px;\n  height: 128px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 4px solid white;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.change-photo-btn {\n  position: absolute;\n  bottom: 10px;\n  right: 0;\n  color: white;\n  padding: 6px 10px;\n  border-radius: 50%;\n  background-image: var(--blue-gradient-angle);\n  cursor: pointer;\n  border: none;\n}\n\n.profile-name {\n  color: #123e68;\n  font-size: 21px;\n  font-weight: 700;\n  margin: 0 0 5px;\n}\n\n.profile-role {\n  color: #52708e;\n  font-size: 14px;\n  letter-spacing: .04em;\n  margin: 0;\n  text-transform: uppercase;\n}\n\n.tabs {\n  background: #fff;\n  border-bottom: 1px solid #dbe6f1;\n  display: flex;\n  padding-left: 14px;\n}\n\n.tab-btn {\n  border-bottom: 3px solid transparent;\n  color: #52708e;\n  cursor: pointer;\n  background: none;\n  border: none;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 14px 24px 12px;\n}\n\n.tab-btn.active-tab {\n  border-bottom-color: #1672b8;\n  color: #12639f;\n}\n\n.tab-btn.disabled {\n  color: #a0aec0;\n  cursor: not-allowed;\n}\n\n.profile-content {\n  padding: 28px 30px 34px;\n  margin-bottom: 0;\n}\n\n.profile-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 0 26px;\n}\n\n.left-column,\n.right-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.profile-input {\n  width: 100%;\n  background: #f8fafc;\n  border: 1px solid #dce5ee;\n  border-radius: 7px;\n  color: #3d5871;\n  font-size: 14px;\n  min-height: 46px;\n  padding: 10px 12px;\n}\n\n.profile-content label {\n  color: #274d70;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 7px;\n}\n\n.profile-content > div:first-child {\n  min-height: 0;\n}\n\n.profile-preview-container > div[style*=\"justify-content: flex-end\"] {\n  padding: 0 30px;\n  position: relative;\n  top: 18px;\n  z-index: 1;\n}\n\n.profile-preview-container .change-btn {\n  align-items: center;\n  display: inline-flex;\n  height: 40px;\n  justify-content: center;\n  padding: 0;\n  width: 40px;\n}\n\n.linkedin-mapping-page {\n  max-width: 1560px;\n  padding-bottom: 28px;\n}\n\n.linkedin-mapping-header {\n  align-items: center;\n  background: linear-gradient(135deg, #ffffff 0%, #f1f7fd 100%);\n  border: 1px solid #d9e5f2;\n  border-radius: 12px;\n  box-shadow: 0 4px 16px rgba(24, 64, 104, .06);\n  display: flex;\n  justify-content: space-between;\n  margin: 14px 0 20px;\n  padding: 22px 26px;\n}\n\n.linkedin-mapping-eyebrow {\n  color: #1765a5;\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: .08em;\n  margin-bottom: 5px;\n}\n\n.linkedin-mapping-header h1 {\n  color: #123e68;\n  font-size: 24px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.linkedin-mapping-header p {\n  color: #647991;\n  font-size: 14px;\n  margin: 5px 0 0;\n}\n\n.linkedin-mapping-header > i {\n  align-items: center;\n  background: #e7f1fb;\n  border: 1px solid #c7ddf0;\n  border-radius: 50%;\n  color: #0a66c2;\n  display: flex;\n  font-size: 22px;\n  height: 48px;\n  justify-content: center;\n  width: 48px;\n}\n\n.linkedin-mapping-card {\n  background: #fff;\n  border: 1px solid #d9e5f2;\n  border-radius: 12px;\n  box-shadow: 0 5px 18px rgba(24, 64, 104, .06);\n  overflow: hidden;\n  padding: 18px;\n}\n\n.linkedin-mapping-table-wrap {\n  overflow-x: auto;\n}\n\n.linkedin-mapping-table {\n  border: 1px solid #cbd9e6 !important;\n  border-collapse: collapse !important;\n  border-color: #cbd9e6 !important;\n  margin-bottom: 0;\n  min-width: 720px;\n}\n\n.linkedin-mapping-table thead th {\n  background: #f1f6fb;\n  border: 1px solid #cbd9e6 !important;\n  color: #17466f;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 14px 12px;\n  vertical-align: middle;\n}\n\n.linkedin-mapping-table tbody td {\n  border: 1px solid #d8e3ee !important;\n  color: #38566f;\n  padding: 14px 12px;\n}\n\n.linkedin-mapping-table tbody tr:hover td {\n  background: #f7fbff;\n}\n\n.linkedin-mapping-table tbody td:first-child {\n  color: #163e63;\n  font-weight: 600;\n}\n\n.linkedin-mapping-table .form-check-input {\n  cursor: pointer;\n  float: none;\n  height: 18px;\n  margin: 0;\n  width: 18px;\n  accent-color: #0a66c2;\n  vertical-align: middle;\n}\n\n.linkedin-mapping-checkbox-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 34px;\n  min-height: 34px;\n  border-radius: 8px;\n}\n\n.linkedin-mapping-checkbox-wrap:has(.linkedin-mapping-checkbox:not(:disabled)) {\n  cursor: pointer;\n}\n\n.linkedin-mapping-checkbox:focus-visible {\n  outline: 3px solid rgba(10, 102, 194, 0.28);\n  outline-offset: 3px;\n}\n\n.linkedin-mapping-table .form-check-input:checked {\n  background-color: #0a66c2;\n  border-color: #0a66c2;\n}\n\n.linkedin-mapping-actions {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 18px;\n}\n\n.linkedin-connect-button {\n  background: #0a66c2;\n  border: 0;\n  border-radius: 7px;\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  min-width: 220px;\n  padding: 10px 16px;\n  justify-content: center;\n  width: auto;\n}\n\n.linkedin-connect-button:hover {\n  background: #07549f;\n}\n\n.upload-resumes .resume-file-card {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #dbe6f1;\n  border-radius: 9px;\n  display: flex;\n  gap: 14px;\n  margin: 8px 0;\n  padding: 13px 14px;\n}\n\n.upload-resumes .resume-file-icon-wrap {\n  align-items: center;\n  background: #edf5fc;\n  border-radius: 8px;\n  display: flex;\n  flex: 0 0 42px;\n  height: 42px;\n  justify-content: center;\n}\n\n.upload-resumes .resume-file-icon-wrap i {\n  font-size: 22px !important;\n  margin: 0 !important;\n}\n\n.upload-resumes .resume-file-details {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.upload-resumes .resume-file-details strong {\n  color: #173f65;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.upload-resumes .resume-file-property-grid {\n  color: #6b8094;\n  display: grid;\n  font-size: 12px;\n  gap: 5px 18px;\n  grid-template-columns: repeat(4, minmax(80px, 1fr));\n  margin-top: 8px;\n}\n\n.upload-resumes .resume-file-property-grid span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.upload-resumes .resume-file-property-grid b {\n  color: #365b7c;\n  display: block;\n  font-size: 10px;\n  letter-spacing: .04em;\n  margin-bottom: 2px;\n  text-transform: uppercase;\n}\n\n.upload-resumes .resume-file-status {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.resume-upload-choice-modal .modal-content {\n  border: 1px solid #d6e4f0;\n  border-radius: 14px;\n  box-shadow: 0 18px 50px rgba(19, 62, 104, .2);\n  overflow: hidden;\n}\n\n.resume-upload-choice-modal .modal-header {\n  background: linear-gradient(135deg, #0e527d, #1a87cb);\n  border-bottom: 0;\n  color: #fff;\n  padding: 18px 22px;\n}\n\n.resume-upload-choice-modal .modal-title {\n  font-size: 19px;\n  font-weight: 700;\n}\n\n.resume-upload-choice-modal .btn-close {\n  filter: brightness(0) invert(1);\n}\n\n.resume-upload-choice-body {\n  background: #f6faff;\n  padding: 24px;\n}\n\n.resume-upload-choice-body > .text-center {\n  background: #fff;\n  border: 1px solid #dce8f2;\n  border-radius: 10px;\n  margin-bottom: 18px !important;\n  padding: 18px;\n}\n\n.resume-upload-pending-list {\n  background: #eef6fd;\n  border: 1px solid #cfe2f2;\n  border-radius: 10px;\n  margin-bottom: 18px;\n  max-height: 230px;\n  overflow-y: auto;\n  padding: 10px;\n}\n\n.resume-upload-file-card {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #d8e5f0;\n  border-radius: 9px;\n  display: flex;\n  gap: 13px;\n  margin-bottom: 8px;\n  padding: 12px;\n}\n\n.resume-upload-file-card:last-child {\n  margin-bottom: 0;\n}\n\n.resume-upload-file-icon {\n  align-items: center;\n  background: #e8f3fc;\n  border-radius: 8px;\n  color: #176ba7;\n  display: flex;\n  flex: 0 0 40px;\n  font-size: 20px;\n  height: 40px;\n  justify-content: center;\n}\n\n.resume-upload-file-icon .resume-file-pdf-icon {\n  color: #d63b43;\n  font-size: 22px;\n}\n\n.resume-upload-file-icon .resume-file-word-icon {\n  color: #2563a8;\n  font-size: 22px;\n}\n\n.resume-native-file-icon {\n  font-size: 24px;\n}\n\n.resume-upload-file-details {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.resume-upload-file-details strong {\n  color: #173f65;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.resume-upload-file-properties {\n  color: #6b8094;\n  display: grid;\n  font-size: 11px;\n  gap: 4px 14px;\n  grid-template-columns: repeat(4, minmax(70px, 1fr));\n  margin-top: 6px;\n}\n\n.resume-upload-file-properties span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.resume-upload-file-properties b {\n  color: #365b7c;\n  display: block;\n  font-size: 9px;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n}\n\n.resume-upload-file-ready {\n  background: #e7f7ef;\n  border: 1px solid #b9e4cc;\n  border-radius: 999px;\n  color: #137a4b;\n  flex: 0 0 auto;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 5px 9px;\n  white-space: nowrap;\n}\n\n.resume-upload-delete-icon {\n  background: #fff0f1;\n  border: 1px solid #f1b9bd;\n  border-radius: 6px;\n  cursor: pointer;\n  flex: 0 0 30px;\n  height: 30px;\n  object-fit: contain;\n  padding: 6px;\n  transition: background-color .2s ease, border-color .2s ease, transform .2s ease;\n  width: 30px;\n}\n\n.resume-upload-delete-icon:hover {\n  background: #dc3545;\n  border-color: #dc3545;\n  transform: scale(1.06);\n}\n\n.swal2-popup.resume-processing-toast {\n  align-items: center !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 9px;\n  border: 1px solid #d6e4ef !important;\n  border-radius: 12px !important;\n  box-shadow: 0 12px 32px rgba(19, 62, 104, .18) !important;\n  margin-top: 12px !important;\n  min-width: 380px;\n  padding: 18px 22px 17px !important;\n  text-align: center !important;\n}\n\n.resume-processing-toast .swal2-title,\n.resume-processing-toast .swal2-html-container {\n  margin: 0 !important;\n  text-align: center !important;\n  width: 100%;\n}\n\n.resume-processing-toast .swal2-icon {\n  margin: 0 auto 2px !important;\n  transform: scale(.62);\n}\n\n.resume-processing-toast .swal2-title {\n  color: #173f65 !important;\n  font-size: 15px !important;\n  line-height: 1.25;\n}\n\n.resume-processing-toast .swal2-html-container {\n  color: #6b8094 !important;\n  font-size: 13px !important;\n}\n\n.resume-processing-toast .swal2-icon.swal2-info {\n  border-color: #2b83c5 !important;\n  color: #2b83c5 !important;\n  margin: 0 auto 2px !important;\n  transform: scale(.78);\n}\n\n.resume-processing-toast .swal2-actions {\n  align-self: center;\n  justify-content: center !important;\n  margin: 4px 0 0 !important;\n  order: 4;\n  width: 100%;\n}\n\n.resume-processing-toast .swal2-confirm {\n  border-radius: 7px !important;\n  box-shadow: none !important;\n  font-weight: 700 !important;\n  margin: 0 !important;\n}\n\n.resume-processing-toast #resume-progress-wrapper,\n.resume-processing-toast #resume-upload-progress-bar,\n.resume-processing-toast #resume-upload-progress-text {\n  box-sizing: border-box;\n}\n\n.resume-processing-toast #resume-upload-progress-bar {\n  background: linear-gradient(90deg, #1269a4, #2f9bd2) !important;\n  border-radius: 999px;\n}\n\n.resume-processing-toast #resume-progress-wrapper > div:first-child {\n  background: #e5edf4 !important;\n  border-radius: 999px !important;\n  box-sizing: border-box;\n  height: 7px !important;\n  margin: 0 !important;\n  width: 100% !important;\n}\n\n.resume-processing-toast #resume-progress-wrapper {\n  box-sizing: border-box !important;\n  margin: 10px 0 0 !important;\n  max-width: 100% !important;\n  order: 3;\n  padding: 0 18px !important;\n  width: 100% !important;\n}\n\n.resume-processing-toast #resume-upload-progress-text {\n  text-align: center !important;\n}\n\n.resume-processing-toast .swal2-html-container {\n  order: 2;\n}\n\n.resume-upload-choice-body .row.g-3 > div > button {\n  border: 1px solid #d6e4ef !important;\n  border-radius: 10px !important;\n  min-height: 96px;\n  transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;\n}\n\n.resume-upload-choice-body .row.g-3 > div > button:hover {\n  border-color: #4a9bd3 !important;\n  box-shadow: 0 6px 16px rgba(14, 82, 125, .1);\n  transform: translateY(-1px);\n}\n\n.job-order-add-candidate-modal .modal-content {\n  border: 1px solid #d4e2ee;\n  border-radius: 14px;\n  box-shadow: 0 20px 55px rgba(12, 50, 82, .24);\n  overflow: hidden;\n}\n\n.job-order-add-candidate-modal.modal-dialog,\n.job-order-add-candidate-modal .modal-dialog {\n  max-width: 820px;\n  width: calc(100% - 28px);\n}\n\n.job-order-add-candidate-modal .modal-header {\n  background: linear-gradient(135deg, #0e527d, #1689c9);\n  border: 0;\n  color: #fff;\n  padding: 17px 20px;\n}\n\n.job-order-add-candidate-modal .modal-title {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.job-order-add-candidate-modal .btn-close {\n  filter: brightness(0) invert(1);\n}\n\n.job-order-add-candidate-body {\n  background: #f6faff;\n  min-height: 0;\n  padding: 22px 20px;\n}\n\n.job-order-upload-tabs {\n  background: #eaf2f9;\n  border-radius: 9px;\n  display: flex;\n  gap: 5px;\n  margin-bottom: 18px;\n  padding: 4px;\n}\n\n.job-order-upload-tabs button {\n  background: transparent !important;\n  border: 0 !important;\n  border-radius: 7px !important;\n  color: #52708e;\n  flex: 1;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 !important;\n  padding: 10px 12px !important;\n}\n\n.job-order-upload-tabs button.btn.border.blueBtn {\n  background: #fff !important;\n  box-shadow: 0 2px 7px rgba(20, 76, 119, .12);\n  color: #0e527d !important;\n}\n\n.job-order-upload-tabs button.btn.border.blueBtn,\n.job-order-upload-tabs button.btn.light {\n  text-indent: 0 !important;\n  visibility: visible !important;\n}\n\n.job-order-add-candidate-body .uploadFileClass {\n  background: #fff !important;\n  border: 2px dashed #8dbbda !important;\n  border-radius: 12px !important;\n  min-height: 170px;\n  padding: 30px 20px !important;\n}\n\n.job-order-upload-icon {\n  align-items: center;\n  background: #e7f3fc;\n  border-radius: 50%;\n  color: #1477b5;\n  display: flex;\n  font-size: 28px;\n  height: 58px;\n  justify-content: center;\n  margin: 0 auto 12px;\n  width: 58px;\n}\n\n.job-order-upload-title {\n  color: #17466f;\n  font-size: 17px;\n  font-weight: 700;\n  margin: 0 0 6px;\n}\n\n.job-order-add-candidate-body .chooseFileSpan {\n  color: #214b6d;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 14px;\n}\n\n.job-order-upload-choices {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  margin-top: 8px;\n}\n\n.job-order-upload-choices button {\n  border-radius: 7px;\n  font-weight: 600;\n  padding: 8px 13px;\n}\n\n.job-order-add-candidate-body .hintText {\n  color: #7890a4;\n  font-size: 12px;\n  margin: 12px 0 0;\n}\n\n.job-order-selected-files {\n  background: #fff;\n  border: 1px solid #d6e4ef;\n  border-radius: 11px;\n  margin-top: 18px;\n  padding: 13px;\n}\n\n.job-order-selected-files-header {\n  align-items: center;\n  border-bottom: 1px solid #e2ebf2;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  padding: 2px 3px 11px;\n}\n\n.job-order-selected-files-header h6 {\n  color: #17466f;\n  font-size: 14px;\n  font-weight: 700;\n  margin: 0 0 2px;\n}\n\n.job-order-selected-files-header span {\n  color: #74899c;\n  font-size: 12px;\n}\n\n.job-order-selected-files-header > i {\n  color: #1b9a63;\n  font-size: 19px;\n}\n\n.job-order-selected-files-list {\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.job-order-add-candidate-body .resume-upload-file-card {\n  margin: 8px 0;\n}\n\n.job-order-existing-candidates {\n  background: #fff;\n  border: 1px solid #d6e4ef;\n  border-radius: 10px;\n  padding: 15px;\n}\n\n.job-order-existing-candidates > label {\n  color: #214b6d;\n  font-size: 14px;\n  font-weight: 700 !important;\n}\n\n.job-order-add-candidate-footer {\n  background: #fff;\n  border-top: 1px solid #dbe6ef;\n  gap: 8px;\n  padding: 14px 20px;\n}\n\n.job-order-add-candidate-footer button {\n  border-radius: 7px !important;\n  font-weight: 600;\n  min-width: 94px;\n}\n\n@media (max-width: 767px) {\n  .upload-resumes .resume-file-card {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .upload-resumes .resume-file-details {\n    max-width: calc(100% - 58px);\n  }\n\n  .upload-resumes .resume-file-property-grid {\n    grid-template-columns: repeat(2, minmax(100px, 1fr));\n  }\n\n  .upload-resumes .resume-file-status {\n    margin-left: 56px;\n  }\n}\n\n@media (max-width: 767px) {\n  .linkedin-mapping-header {\n    align-items: flex-start;\n    gap: 14px;\n    padding: 18px;\n  }\n\n  .linkedin-mapping-header > i {\n    display: none;\n  }\n\n  .linkedin-mapping-card {\n    padding: 10px;\n  }\n}\n\n@media (max-width: 767px) {\n  .profile-header,\n  .profile-content {\n    padding-left: 18px;\n    padding-right: 18px;\n  }\n\n  .profile-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .profile-preview-container > div[style*=\"justify-content: flex-end\"] {\n    padding-right: 18px;\n  }\n}\n\n.password-container {\n  display: flex;\n  gap: 10px;\n}\n\n.change-btn {\n  padding: 8px 16px;\n  background-image: var(--blue-gradient-angle);\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  border: none;\n}\n\n.change-btn:hover {\n  background-color: #2b6cb0;\n}\n\n.update-btn,\n.upload-btn {\n  width: fit-content;\n  padding: 6px 16px;\n  background-image: var(--blue-gradient-angle);\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  border: none;\n}\n\n.update-btn:hover,\n.upload-btn:hover {\n  background-color: #2b6cb0;\n}\n\n.password-dialog,\n.photo-dialog {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  /* background-color: rgba(0, 0, 0, 0.5); */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n\n.dialog-content {\n  background-color: white;\n  padding: 30px 30px;\n  border-radius: 4px;\n  width: 28vw;\n  box-shadow: -1px -1px 12px 7px #f1f1f1e6;\n}\n\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.close-btn {\n  font-size: 14px;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.drop-zone {\n  border: 2px dashed #cbd5e0;\n  padding: 40px;\n  text-align: center;\n  border-radius: 8px;\n  display: flex;\n  justify-content: end;\n}\n\n.choose-file-btn {\n  padding: 10px 20px;\n  background-color: #3182ce;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.choose-file-btn:hover {\n  background-color: #2b6cb0;\n}\n\n\n.Change-password {\n  display: flex !important;\n  justify-content: space-between !important;\n  margin-bottom: 13px !important;\n}\n\n.preview-image-container {\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.preview-image {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.upload-resumes .custom-choose-btn .p-button-rounded .p-button-outlined .p-button .p-fileupload-choose .p-component .p-button-icon-only {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  border: 1px solid var(--backclr);\n  color: var(--white);\n  padding: 7px 18px;\n}\n\n.upload-resumes .p-button {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  border: 1px solid var(--backclr);\n  color: var(--white);\n  padding: 7px 18px;\n  border-radius: 100%;\n}\n\n.import-head{\n    font-size: 16px;\n    font-weight: 500;\n}\n.import-head {\n  font-size: 16px;\n  font-weight: 500;\n\n}\n\n.import-fw {\n  font-weight: 500;\n}\n\n.main-button {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  color: var(--white);\n  border: none !important;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n}\n\n.upload-resumes .p-fileupload-content i{\n  display: none;\n}\n\n\n.upload-resumes .p-fileupload-content span{\n  margin: 0 !important;\n  padding: 0px !important;\n  font-size: 15px !important;\n  justify-content: start;\n}\n\n.clr-icons {\n  display: flex;\n  justify-content: end;\n}\n\n.actionitem-import .csvbtn.p-button {\n  color: var(--white);\n  background: #06b6d4;\n  border: none;\n  border-radius: 50%;\n  font-size: 16px;\n  width: 36px;\n  height: 36px;\n}\n.actionitem-import .xlsbtn.p-button {\n  color: var(--white);\n  background: #22c55e;\n  border: none;\n  border-radius: 50%;\n  font-size: 16px;\n  width: 36px;\n  height: 36px;\n}\n.actionitem-import .pdfbtn.p-button {\n  color: var(--white);\n  background: #f97316;\n  border: none;\n  border-radius: 50%;\n  font-size: 16px;\n  width: 36px;\n  height: 36px;\n}\n\n.usermanagement-tab .p-datatable .p-datatable-tbody > tr > td{\n  padding: 0.1rem 1rem;\n}\n\n.profile-dropdown .p-cascadeselect-item-active>.p-cascadeselect-sublist-wrapper {\n  display: block;\n  left: -123% !important;\n  top: 46px !important;\n}\n\n\n/* tab section css start */\n\n.dynamic-tab .p-button {\n  background-color: transparent;\n  border: none;\n  color: var(--black);\n  padding: 2px 0px;\n  margin: 0;\n}\n\n.dynamic-tab .p-button.p-button-icon-only {\n  width: 20px;\n  background: transparent;\n}\n\n.footer-tabsec .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  padding: 3px 10px !important;\n  border: 1px solid #e0e0ea3d;\n  border-radius: 5px;\n}\n .p-menu-list{\n  padding-left: 0 !important;\n}\n\n/* tab section css end */\n\n/* Pipeline Accordian start */\n\n\n.pipeline-acc .p-datatable .p-datatable-tbody > tr > td{\n  padding: 0rem 1rem;\n}\n\n/* Pipeline Accordian end */\n\n\n/* auto complete start */\n\n.p-autocomplete-items{\n  padding-left: 0px;\n}\n\n\n.footer-tabsec, .dynamic-tab {\n  width: 100%;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.tabsmargin{\n  margin-top: 100px;\nmargin-bottom: 100px;\n}\n\n\n\n\n.expanded-row {\n  background-color: #f0f8ff !important; /* Light blue background for expanded rows */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
